// extracted by mini-css-extract-plugin
export default {"main":"About_main__hMFL7","card":"About_card__AIHmy"};